"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIPopoverHeader;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _colors = require("HubStyleTokens/colors");

var _misc = require("HubStyleTokens/misc");

var _sizes = require("HubStyleTokens/sizes");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _PopoverContext = require("../context/PopoverContext");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UIPopoverCloseButton = _interopRequireDefault(require("./UIPopoverCloseButton"));

var Header = _styledComponents.default.header.withConfig({
  displayName: "UIPopoverHeader__Header",
  componentId: "g32oto-0"
})(["display:flex;justify-content:space-between;align-items:flex-start;background:inherit;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:inherit;border-top-right-radius:inherit;padding:", ";", ";h1,h2,h3,h4,h5,h6{", "}"], function (_ref) {
  var flush = _ref.flush,
      popoverUse = _ref.popoverUse;
  if (flush) return '0';
  if (popoverUse === 'longform') return _sizes.POPOVER_PADDING_Y + " " + _sizes.TOOLTIP_LONGFORM_PADDING + " 0";
  if (popoverUse === 'shepherd') return _sizes.SHEPHERD_PADDING_Y + " " + _sizes.POPOVER_PADDING_X;
  return _sizes.POPOVER_PADDING_Y + " " + _sizes.POPOVER_PADDING_X + " 0";
}, function (_ref2) {
  var popoverUse = _ref2.popoverUse;
  return popoverUse === 'shepherd' && (0, _styledComponents.css)(["background:", ";border-top-right-radius:inherit;border-top-left-radius:inherit;color:", ";"], _colors.THUNDERDOME, _colors.OLAF);
}, function (_ref3) {
  var popoverUse = _ref3.popoverUse;
  if (popoverUse === 'longform') return (0, _styledComponents.css)(["font-size:", ";font-weight:", ";text-transform:none;margin-bottom:8px;"], _sizes.HEADING5, _misc.HEADING_WEIGHT5);
  return 'margin-bottom: 0';
});

function UIPopoverHeader(_ref4) {
  var className = _ref4.className,
      children = _ref4.children,
      onOpenChange = _ref4.onOpenChange,
      showCloseButton = _ref4.showCloseButton,
      rest = (0, _objectWithoutProperties2.default)(_ref4, ["className", "children", "onOpenChange", "showCloseButton"]);
  var popoverUse = (0, _react.useContext)(_PopoverContext.PopoverContext).use;
  return _react.default.createElement(Header, Object.assign({}, rest, {
    className: (0, _classnames.default)('uiPopoverHeader private-popover__header', className),
    popoverUse: popoverUse
  }), children, showCloseButton && _react.default.createElement(_UIPopoverCloseButton.default, {
    popoverUse: popoverUse,
    onClick: function onClick() {
      if (onOpenChange) onOpenChange((0, _SyntheticEvent.default)(false));
    }
  }));
}

UIPopoverHeader.propTypes = {
  children: _propTypes.default.node,
  flush: _propTypes.default.bool,
  showCloseButton: _propTypes.default.bool,
  onOpenChange: _propTypes.default.func
};
UIPopoverHeader.displayName = 'UIPopoverHeader';
module.exports = exports.default;